import { Dictinary } from "@app/shared/models";
import { createAction, props } from "@ngrx/store";

export const loadAges = createAction("[Directory / API] Load Ages");

export const loadAgesSuccess = createAction(
  "[Directory / API] Load Ages Success",
  props<{ ages: Dictinary[] }>(),
);

export const loadAgesFailure = createAction(
  "[Directory / API] Load Ages Failure",
  props<{ error: any }>(),
);
